"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Input_1 = __importDefault(require("../../Input"));
var Field_1 = __importDefault(require("./Field"));
var Context_1 = require("../Context");
var utils_1 = require("../utils");
var useStringValueValidation_1 = __importDefault(require("./hooks/useStringValueValidation"));
var Box_1 = __importStar(require("../../Box"));
var styled_1 = __importDefault(require("@emotion/styled"));
var IconButton_1 = __importDefault(require("../../IconButton"));
var styled_system_1 = require("styled-system");
var CustomizedFileFieldBox = (0, Box_1.createBasicComponent)((0, styled_system_1.variant)({ scale: 'inputs' }));
CustomizedFileFieldBox.defaultProps = {
    variant: 'v2',
};
exports.default = react_1.default.forwardRef(function InputField(props, ref) {
    var 
    /* field props start*/
    label = props.label, name = props.name, required = props.required, validate = props.validate, disableLabelBox = props.disableLabelBox, fieldBasis = props.fieldBasis, bottomContent = props.bottomContent, 
    /* field props end */
    /* local props start */
    length = props.length, numeric = props.numeric, onChange = props.onChange, onBlur = props.onBlur, 
    /* local props start */
    _a = props.placeholder, 
    /* local props start */
    placeholder = _a === void 0 ? '' : _a, iconName = props.iconName, onIconClick = props.onIconClick, iconProps = props.iconProps, children = props.children, // for customized file field only
    inputProps = __rest(props, ["label", "name", "required", "validate", "disableLabelBox", "fieldBasis", "bottomContent", "length", "numeric", "onChange", "onBlur", "placeholder", "iconName", "onIconClick", "iconProps", "children"]);
    var minLength = props.minLength, maxLength = props.maxLength;
    if (length) {
        minLength = length;
        maxLength = length;
    }
    var fieldProps = {
        label: label,
        name: name,
        required: required,
        validate: validate,
        disableLabelBox: disableLabelBox,
        fieldBasis: fieldBasis,
        bottomContent: bottomContent
    };
    (0, useStringValueValidation_1.default)(name);
    var formContext = (0, Context_1.useFormContext)();
    var formId = formContext.formId, values = formContext.values, isSubmitting = formContext.isSubmitting, handleFormikChange = formContext.handleChange, handleFormikBlur = formContext.handleBlur, errors = formContext.errors, touched = formContext.touched;
    var handleChange = function (event) {
        if (inputProps.type === 'tel') {
            // only allows number and +
            event.target.value = event.target.value.replace(/[^0-9+]/g, '');
        }
        else if (numeric) {
            // only allows number
            event.target.value = event.target.value.replace(/\D/g, '');
        }
        // use manual way to do it instead of maxLength in html attribute
        // because it makes copy/paste still work for (111) 222-3333 which could have been cut off by input attribute maxLength
        if (maxLength && maxLength >= 0) {
            event.target.value = event.target.value.substring(0, maxLength);
        }
        handleFormikChange(event);
        // custom onChange
        onChange === null || onChange === void 0 ? void 0 : onChange(event, formContext);
    };
    var handleBlur = function (event) {
        handleFormikBlur(event);
        // custom onBlur
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event, formContext);
    };
    var handleValidate = function (value) {
        var trimmedValue = value.trim();
        if (minLength && minLength >= 0 // when minLength is defined
            && trimmedValue.length < minLength) { // validate if value meets the minimal length requirement
            return "Please enter at least " + minLength + " character" + (minLength > 1 ? 's' : '');
        }
        if (validate) {
            return validate(value);
        }
    };
    var pattern;
    if (inputProps.type === 'tel') {
        // allows number and +
        pattern = '[0-9+]*';
    }
    else if (numeric) {
        pattern = '[0-9]*';
    }
    var inputMode = 'text';
    if (inputProps.type === 'tel') {
        inputMode = 'tel';
    }
    else if (numeric) {
        inputMode = 'numeric';
    }
    var hasError = errors[name] && touched[name] ? 'error' : undefined;
    return (react_1.default.createElement(Field_1.default, __assign({}, fieldProps, { validate: handleValidate }),
        react_1.default.createElement(Box_1.default, { position: "relative" },
            inputProps.type === 'file' && children && (react_1.default.createElement(CustomizedFileFieldBox, { className: hasError },
                react_1.default.createElement("label", { htmlFor: (0, utils_1.getIdName)(formId, name) }, children))),
            react_1.default.createElement(Input_1.default, __assign({ className: hasError, type: 'text', pattern: pattern, inputMode: inputMode }, inputProps, { ref: ref, variant: 'v2', id: (0, utils_1.getIdName)(formId, name), name: name, placeholder: label ? '' : "" + placeholder + (required && placeholder ? '*' : ''), value: values[name], onChange: handleChange, onBlur: handleBlur, disabled: isSubmitting || inputProps.disabled, minLength: undefined, maxLength: undefined })),
            iconName && react_1.default.createElement(StyledIcon, __assign({ icon: iconName, color: 'black', onClick: onIconClick }, iconProps)))));
});
var StyledIcon = (0, styled_1.default)(IconButton_1.default)({
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)'
});
